import { RouteConfig } from "vue-router"
import Home from "@/views/Home/index.vue"
import History from "@/views/history/index.vue"

const publicRoutes: Array<RouteConfig> = [
    {
        path: "/",
        name: "gamesLists",
        component: Home,
    },
    {
        path: "/history",
        name: "history",
        component: History,
    },
]

export default publicRoutes
